import type { App } from "vue";
import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from "vue-router";

export const constantRoutes: RouteRecordRaw[] = [
  /* 榜单 */
  {
    path: "/rank",
    children: [
      /* 总榜单 */
      {
        path: "allRank",
        name: "allRank",
        component: () => import("@/views/rank/allRank/index.vue"),
        meta: { title: "排行榜" },
      },
      /* 总榜单(新) */
      {
        path: "allRankNew",
        name: "allRankNew",
        component: () => import("@/views/rank/allRankNew/index.vue"),
        meta: { title: "排行榜" },
      },
      /* 私房榜单 */
      {
        path: "privateRank",
        name: "privateRank",
        component: () => import("@/views/rank/privateRank/index.vue"),
      },
      /* 日榜 */
      {
        path: "dayRank",
        name: "dayRank",
        component: () => import("@/views/rank/dayRank/index.vue"),
      },
      /* 俱乐部半屏榜单 */
      {
        path: "club",
        name: "club",
        component: () => import("@/views/rank/club/index.vue"),
      },
      /* 俱乐部分享页 */
      {
        path: "groupShare",
        name: "groupShare",
        component: () => import("@/views/rank/groupShare/index.vue"),
      },
      /* 俱乐部说明页 */
      {
        path: "groupIntruduction",
        name: "groupIntruduction",
        component: () => import("@/views/rank/groupIntruduction/index.vue"),
      },
      /* 珍愛團榜單 */
      {
        path: "treasureGroup",
        name: "treasureGroup",
        component: () => import("@/views/rank/treasureGroup/index.vue"),
      },
      /* 積分貢獻榜 */
      {
        path: "treasureGroupPoints",
        name: "treasureGroupPoints",
        component: () => import("@/views/rank/treasureGroupPoints/index.vue"),
      },
      /* 珍愛團記錄 */
      {
        path: "treasureGroupRecords",
        name: "treasureGroupRecords",
        component: () => import("@/views/rank/treasureGroupRecords/index.vue"),
      },
      /* FirstLove榜单 */
      {
        path: "firstLove",
        name: "firstLove",
        component: () => import("@/views/rank/firstLove/index.vue"),
      },
      {
        path: "firstLove/rule",
        name: "firstLoveRule",
        component: () => import("@/views/rank/firstLove/rule.vue"),
      },
      /* 新社团榜单 */
      {
        path: "newClub",
        name: "newClub",
        component: () => import("@/views/rank/newClub/index.vue"),
      },
      /* 新星榜 */
      {
        path: "newStar",
        name: "newStar",
        component: () => import("@/views/rank/newStar/index.vue"),
      },
      /* TOP集合页 */
      {
        path: "topRankList",
        name: "topRankList",
        component: () => import("@/views/rank/topRankList/index.vue"),
      },
    ],
  },
  /* 邀请有奖 */
  {
    path: "/newShare",
    children: [
      /* 总榜单 */
      {
        path: "shareRank",
        name: "shareRank",
        component: () => import("@/views/newShare/shareRank/index.vue"),
        meta: { title: "排行榜" },
      },
    ],
  },
  /* ==========游戏============ */
  /* 萤火花园游戏 */
  {
    path: "/games/fireflyGarden",
    name: "fireflyGarden",
    component: () => import("@/views/games/fireflyGarden/index.vue"),
    meta: { title: "萤火花园" },
  },
  {
    path: "/games/fflyGarden", // 新地址 避免被客户端替换firefly的文本
    name: "fflyGarden",
    component: () => import("@/views/games/fireflyGarden/index.vue"),
    meta: { title: "萤火花园" },
  },
  {
    path: "/games/fflyGarden/rank",
    name: "fflyGardenRank",
    component: () => import("@/views/games/fireflyGarden/Rank.vue"),
    meta: { title: "萤火花园排行榜" },
  },
  /* 极速狂飙游戏 */
  {
    path: "/games/kingOfSpeed",
    name: "kingOfSpeed",
    component: () => import("@/views/games/kingOfSpeed/index.vue"),
    meta: { title: "极速狂飙" },
  },
  /* 水果转盘游戏 */
  {
    path: "/games/fruitTurntable/record",
    name: "fruitTurntableRecord",
    component: () => import("@/views/games/fruitTurntable/record.vue"),
    meta: { title: "水果转盘记录" },
  },
  {
    path: "/games/fruitTurntable/rule",
    name: "fruitTurntableRule",
    component: () => import("@/views/games/fruitTurntable/rule.vue"),
    meta: { title: "水果转盘玩法说明" },
  },
  /* 飞行棋游戏 */
  {
    path: "/games/ludo/channel",
    name: "ludoChannel",
    component: () => import("@/views/games/ludo/channel.vue"),
    meta: { title: "飞行棋LUDO渠道大厅" },
  },
  {
    path: "/games/ludo/rank",
    name: "ludoRank",
    component: () => import("@/views/games/ludo/rank.vue"),
    meta: { title: "飞行棋LUDO排行榜" },
  },
  {
    path: "/games/ludo/record",
    name: "ludoRecord",
    component: () => import("@/views/games/ludo/record.vue"),
    meta: { title: "飞行棋LUDO记录" },
  },
  {
    path: "/games/ludo/rule",
    name: "ludoRule",
    component: () => import("@/views/games/ludo/rule.vue"),
    meta: { title: "飞行棋LUDO规则" },
  },
  {
    path: "/games/ludo/info",
    name: "ludoInfo",
    component: () => import("@/views/games/ludo/info.vue"),
    meta: { title: "飞行棋LUDO玩法信息" },
  },
  {
    path: "/games/ludo/props",
    name: "ludoProps",
    component: () => import("@/views/games/ludo/props.vue"),
    meta: { title: "飞行棋LUDO道具信息" },
  },
  /* 三张牌游戏 */
  {
    path: "/games/teenPatti/channel",
    name: "teenPattiChannel",
    component: () => import("@/views/games/teenPatti/channel.vue"),
    meta: { title: "三张牌渠道大厅" },
  },
  {
    path: "/games/teenPatti/rank",
    name: "teenPattiRank",
    component: () => import("@/views/games/teenPatti/rank.vue"),
    meta: { title: "三张牌排行榜" },
  },
  {
    path: "/games/teenPatti/record",
    name: "teenPattiRecord",
    component: () => import("@/views/games/teenPatti/record.vue"),
    meta: { title: "三张牌记录" },
  },
  {
    path: "/games/teenPatti/rule",
    name: "teenPattiRule",
    component: () => import("@/views/games/teenPatti/rule.vue"),
    meta: { title: "三张牌规则" },
  },
  {
    path: "/games/teenPatti/info",
    name: "teenPattiInfo",
    component: () => import("@/views/games/teenPatti/info.vue"),
    meta: { title: "三张牌玩法信息" },
  },
  {
    path: "/games/teenPatti/props",
    name: "teenPattiProps",
    component: () => import("@/views/games/teenPatti/props.vue"),
    meta: { title: "三张牌道具信息" },
  },
  /* 水果转盘 */
  {
    path: "/games/fruitTurntable/record",
    name: "fruitTurntableRecord",
    component: () => import("@/views/games/fruitTurntable/record.vue"),
    meta: { title: "水果转盘记录" },
  },
  {
    path: "/games/fruitTurntable/rule",
    name: "fruitTurntableRule",
    component: () => import("@/views/games/fruitTurntable/rule.vue"),
    meta: { title: "水果转盘规则" },
  },
  /* ===========活动=========== */
  /* 夜间选秀 */
  {
    path: "/activity/nightDraft",
    name: "nightDraft",
    component: () => import("@/views/activity/nightDraft/index.vue"),
    meta: { title: "夜间选秀" },
  },
  {
    path: "/activity/nightDraft/pastEvent",
    name: "pastEvent",
    component: () => import("@/views/activity/nightDraft/pastEvent.vue"),
    meta: { title: "往期夜间选秀" },
  },
  {
    path: "/activity/nightDraft/rule",
    name: "nightDraftRule",
    component: () => import("@/views/activity/nightDraft/rule.vue"),
    meta: { title: "夜间选秀规则" },
  },
  /* 上播助手 */
  {
    path: "/activity/videoAssistant",
    name: "videoAssistant",
    component: () => import("@/views/activity/videoAssistant/index.vue"),
    meta: { title: "上播助手" },
  },
  /* 迎新奖励 */
  {
    path: "/activity/newsRewards",
    name: "newsRewards",
    component: () => import("@/views/activity/newsRewards/index.vue"),
    meta: { title: "迎新奖励" },
  },
  {
    path: "/activity/newsRewards/rule",
    name: "newsRewardsRule",
    component: () => import("@/views/activity/newsRewards/rule.vue"),
    meta: { title: "迎新奖励活动规则" },
  },
  {
    path: "/activity/newsRewards/record",
    name: "newsRewardsRecord",
    component: () => import("@/views/activity/newsRewards/record.vue"),
    meta: { title: "迎新奖励记录" },
  },
  /* vip引导添加运营页 */
  {
    path: "/nesting/vipGuide",
    name: "vipGuide",
    component: () => import("@/views/nesting/vipGuide/index.vue"),
    meta: { title: "VIP引导" },
  },
  {
    path: "/nesting/cooperate",
    name: "cooperate",
    component: () => import("@/views/nesting/cooperate/index.vue"),
    meta: { title: "合作联系" },
  },
  {
    path: "/nesting/cooperate/connect",
    name: "cooperate/connect",
    component: () => import("@/views/nesting/cooperate/connect.vue"),
    meta: { title: "合作推广" },
  },
  /* 靓号启用承诺书 */
  {
    path: "/nesting/premiunNumberCommitLetter",
    name: "premiunNumberCommitLetter",
    component: () =>
      import("@/views/nesting/premiunNumberCommitLetter/index.vue"),
    meta: { title: "靓号启用承诺书" },
  },
  /* vip特权调整说明 */
  {
    path: "/nesting/vipUpPublicNotice",
    name: "vipUpPublicNotice",
    component: () => import("@/views/nesting/vipUpPublicNotice/index.vue"),
    meta: { title: "vip特权调整说明" },
  },
  /* vip等级提升页面 */
  {
    path: "/nesting/vipLevelUp",
    name: "vipLevelUp",
    component: () => import("@/views/nesting/vipLevelUp/index.vue"),
    meta: { title: "vip等级提升" },
  },
  /* 首充页面改版 */
  {
    path: "/nesting/firstCharge",
    name: "firstCharge",
    component: () => import("@/views/nesting/firstCharge/index.vue"),
    meta: { title: "首充" },
  },
  /* 社团-任命社长 */
  {
    path: "/nesting/clubs/setPresident",
    name: "setPresident",
    component: () => import("@/views/nesting/clubs/setPresident.vue"),
    meta: { title: "社团任命社长" },
  },
];

/**
 * 创建路由
 */
const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

// 全局注册 router
export function setupRouter(app: App<Element>) {
  app.use(router);
}

export default router;
